<div class="main-container">
  <div #main id="main">
    <app-main-section (emitScroll)="scrollToSection('registration')"></app-main-section>
  </div>
  <div #place id="organizers">
    <app-images-slider-section [imagesCards]="[
    {
            title: 'ОРГАНИЗАТОР',
            firstText: 'Дэн Мильштейн – сертифицированный агент NHLPA. Основатель Gold Star Group. ',
            secondText: 'Автор книг: «Правило №1 – Никогда Не Быть №2», «Агент №1» и др. Исполнительный продюсер фильма «Русская пятерка».',
            thirdText: '«Моя задача — не просто заключать контракты, а строить карьеру игрока так, чтобы он оставил след в истории» Дэн Мильштейн',
            img: '/app/assets/bg/director.png',
            achievements: true,
            pos: '69% 50%'
          },
          {
            title: 'ОРГАНИЗАТОР',
            firstText: 'Gold Star Hockey, основанная Дэном Мильштейном в 2000 году, стартовала с представления интересов Павла Дацюка. Вокруг него компания выстроила свои компетенции, а затем открылась для других талантов. ',
            secondText: 'Сегодня агентство объединяет свыше 150 игроков по всему миру, включая 8 обладателей Кубка Стэнли, воплощая мечты в хоккейные триумфы.',
            img: '/app/assets/bg/team.jpg',
            profit: true,
           pos: '57.5% 50%'
          },
    ]"/>
  </div>
  <div #place id="place">
    <app-place-section ></app-place-section>
  </div>
  <div #coach id="coach">
    <app-images-slider-section [imagesCards]="[
    {
            title: 'Главный тренер',
            firstText: 'Шведский тренер Тэд Сухконен – известный специалист по технике катания и работе с клюшкой и шайбой. ',
            secondText: 'В своей тренерской карьере он успел поработать в Федерациях хоккея США и Германии, в сборной Норвегии, в клубах «Амбри-Пиотта» (Швейцария), «Комет», «Лоренског» (оба – Норвегия).',
            img: '/app/assets/bg/coach.png',
            pos: '57.5% 50%'
          },
          {
            title: 'Приглашенный специалист',
            firstText: '',
            secondText: 'Никита Филатов — талантливый российский хоккеист, завершивший профессиональную карьеру, и ныне известный хоккейный аналитик, эксперт и медийная личность. ',
            img: '/app/assets/bg/special.jpeg',
            pos: '50% 50%'
          },
    ]"/>
  </div>
  <div id="goal">
    <app-goal-section ></app-goal-section>
  </div>
  <div id="services">
    <app-services-section/>
  </div>
  <div #schedule id="schedule">
    <app-schedule-section (emitClick)="scrollToSection('registration')"></app-schedule-section>
  </div>
  <div id="images">
    <app-images-scroll [imagesCards]="[
    {
      title: '#WEAREGOLDSTAR!',
      firstText: 'Хоккейные сборы — это важный этап в карьере каждого игрока, открывающий новые горизонты \n'+
'для совершенствования. Они становятся мощным импульсом в развитии мастерства хоккеиста, \n'+
'позволяя вывести игру на качественно новый уровень. ',
      secondText: 'Мы предлагаем профессиональную поддержку от опытных специалистов и создаем комфортные условия,\n'+
'чтобы вы могли полностью сосредоточиться на своем росте и достижении целей.',
      img: '/app/assets/images/pucks.jpg',
    },
    {
      title: '#WEAREGOLDSTAR!',
      firstText: '',
      secondText: '',
      img: '/app/assets/images/coachTalk.png',
    },
    {
      title: '#WEAREGOLDSTAR!',
      firstText: '',
      secondText: '',
      img: '/app/assets/images/pucks.jpg',
      video: 'app/assets/video/training.mp4',
    },
    {
      title: '#WEAREGOLDSTAR!',
      firstText: '',
      secondText: '',
      img: '/app/assets/images/boys.jpeg',
    },
    ]"/>
  </div>
  <div id="registration">
    <app-registration-section ></app-registration-section>
  </div>
</div>
